// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"79":"component---src-templates-index-tsx","351":"commons","536":"component---src-templates-blog-tsx"}[chunkId] + "-" + {"79":"5f2c80d7b90f4fdccf4c","351":"8dcf4ffde13b8329d6cf","536":"ca23d409353b0cc69934"}[chunkId] + ".js";
};